
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire54e0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire54e0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("eTlXk", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ad773bbfa59cf6ee$export$6503ec6e8aabbaf; }, function (v) { return $ad773bbfa59cf6ee$export$6503ec6e8aabbaf = v; });
var $ad773bbfa59cf6ee$export$6503ec6e8aabbaf;
var $ad773bbfa59cf6ee$export$f7ad0328861e2f03;
"use strict";
var $ad773bbfa59cf6ee$var$mapping = new Map();
function $ad773bbfa59cf6ee$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ad773bbfa59cf6ee$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ad773bbfa59cf6ee$var$resolve(id) {
    var resolved = $ad773bbfa59cf6ee$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ad773bbfa59cf6ee$export$6503ec6e8aabbaf = $ad773bbfa59cf6ee$var$register;
$ad773bbfa59cf6ee$export$f7ad0328861e2f03 = $ad773bbfa59cf6ee$var$resolve;

});

var $1e71fbda58cdf7e7$exports = {};

(parcelRequire("eTlXk")).register(new URL("", import.meta.url).toString(), JSON.parse('["hZ8Bi","index.c7d87a23.js","dYIYP","kitas_in_flensburg.78949304.geojson","buEIH","flensburg_stadtteile.38166253.geojson","di4YJ","marker-icon-default.3c471951.webp","eF7Z3","marker-icon-active.b40abc59.webp","jySMm","index.f4088dd9.css"]'));


//# sourceMappingURL=index.runtime.c4d6ec18.js.map
